export default "__VITE_ASSET__CaC4Iulw__"